/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'snap-scroller';

/**
 * This is the component description.
 */
const SnapScroller = ({
  id,
  className: userClassName,
  style,
  children,
  noScrollOnDesktop
  // ...otherProps
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [startScrollX, setStartScrollX] = useState(0);
  const ref = useRef(null);
  const onMouseDown = e => {
    setIsDragging(true);
    setStartX(e.clientX);
    setStartScrollX(ref.current.scrollLeft);
  };
  const onMouseUp = () => {
    setIsDragging(false);
  };
  const onMouseMove = e => {
    if (isDragging) {
      const deltaX = e.clientX - startX;
      ref.current.scrollLeft = startScrollX - deltaX;
    }
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React.createElement("div", {
      id: id,
      className: [baseClassName, componentClassName, userClassName, noScrollOnDesktop && 'desktop-no-scroll'].filter(e => e).join(' '),
      style: style,
      ref: ref,
      onMouseDown: noScrollOnDesktop ? null : onMouseDown,
      onMouseUp: noScrollOnDesktop ? null : onMouseUp,
      onMouseMove: noScrollOnDesktop ? null : onMouseMove
      // {...otherProps}
    }, children)
  );
};
SnapScroller.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The children JSX
   */
  children: PropTypes.node,
  /**
   * Whether to snap scroll on desktop (false will enable a flexbox)
   */
  noScrollOnDesktop: PropTypes.bool
};
SnapScroller.defaultProps = {
  noScrollOnDesktop: false
};
export default SnapScroller;